module.exports = "/_next/static/images/ChooseFromDestinations@2x-cd2c7d5d84f9447c038b7af831e8c926.png";